import { useState, useEffect, useRef } from 'react';

interface LoadingIndicatorProps {
}

export default function LoadingIndicator() {
  return (
    <div className="rounded-lg p-4">
      <div className="w-full h-64  rounded flex flex-col items-center justify-center">
        <div className="flex gap-1 mb-4">
          <div className="w-3 h-3 bg-[#00FFBF] rounded-full animate-bounce" />
          <div
            className="w-3 h-3 bg-[#FF0090] rounded-full animate-bounce"
            style={{ animationDelay: '0.1s' }}
          />
          <div
            className="w-3 h-3 bg-[#FCAF28] rounded-full animate-bounce"
            style={{ animationDelay: '0.2s' }}
          />
        </div>
      </div>
    </div>
  );
}